<template>
  <div class="form-group">
    <label v-if="label" :for="`datepicker-${_uid}`">{{ label }}</label>

    <b-form-datepicker
      :placeholder="placeholder"
      v-model="inputValue"
      :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
      @input="onInput"
      :class="customClass"
      :min="min" :max="max"
    >
      <template v-slot:button-content>
        <i class="icon-calendar"></i>
      </template>
    </b-form-datepicker>

    <b-form-invalid-feedback :id="`input-live-feedback-${_uid}`" v-if="showErrors">
      <ul class="error-content">
        <li class="error-text" v-for="(error, index) in errors" :key="`input-datepicker-error-${_uid}-${index}`">
          {{ error }}
        </li>
      </ul>
    </b-form-invalid-feedback>
  </div>
</template>

<script>
import {InputMixins} from "@/core/components/Form/Mixins/input";

export default {
  name: "DatePicker",
  data: function () {
    return {}
  },
  mixins: [InputMixins],
  props: {
    min: {
      type: Date,
    },
    max: {
      type: Date,
    },
    classDatePicker: {
      type: String,
    },
  },
  methods: {
    onInput(value) {
      this.$emit('input', value)
    },
  },
  computed: {
    customClass() {
      const className = {}

      className[this.classDatePicker] = !!this.classDatePicker
      className['is-invalid'] = this.state === false

      return {
        ...className
      }
    },
  }
}
</script>

<style lang="stylus" scoped>
@import "~@/core/styles/variables.styl"

.b-form-datepicker
  > button
    padding 0

    .icon-calendar
      padding 7px 20px
      max-height none
      position absolute
      right 0
      top 0
      height 100%

      &:before
        color color-3
        vertical-align middle
        text-align center

  ::v-deep
    .dropdown-menu
      .b-form-date-calendar
        .b-calendar-inner
          .form-control
            border  none
            max-height none

::v-deep
  footer
  output
    display none

  button
    padding 0

  .no-gutters
  .no-gutters > .col
  .no-gutters > [class*=col-]
    padding-right 0 !important
    padding-left 0 !important
    margin 0 !important

  label.form-control
    padding 7px 20px !important


</style>
